import { DataApiJobsPage } from "./dataapi/DataApiJobs";

export const AtgolorsdataapiPage = DataApiJobsPage;
